import { FC, Fragment } from "react";
import { SegmentType } from "src/Modules/Flights/constants";
import FlightCard from "../../../FlightCard/FlightCard";
import { FlightLayover } from "../../../FlightCard/components";

const SegmentBody: FC<{ segment: SegmentType }> = ({ segment }) => {
  return (
    <div className="flex flex-col gap-3">
      {segment.flights.map((flight, index) => {
        return (
          <Fragment key={`flight-${index}`}>
            <FlightCard flight={flight} />
            <FlightLayover layover={segment.layovers?.[index]} />
          </Fragment>
        );
      })}
    </div>
  );
};

export default SegmentBody;;

